export enum Paths {
  main = 'main',
  newTemplate = 'new_template',
  editTemplate = 'edit_template'
}
